import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import type { DependencyPlan } from '@cli-types/next-adapter/init.js'
import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { CORE_DEPS, DEV_DEPS, LINTER_DEV_DEPS } from '@cli-constants/deps.js'
import { unique } from '@cli-utils/shared.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { getPresetDefinition } from '@next-adapter/preset-registry.js'

export function getDependencyPlan(
  presetIds: BetterstartPresetId[],
  integrationIds: BetterstartIntegrationId[],
  includeLinter: boolean
): DependencyPlan {
  const presetDependencies = presetIds.flatMap(
    (presetId) => getPresetDefinition(presetId).packageDependencies
  )
  const presetDevDependencies = presetIds.flatMap(
    (presetId) => getPresetDefinition(presetId).devDependencies
  )
  const integrationDependencies = integrationIds.flatMap(
    (integrationId) => getIntegrationDefinition(integrationId).packageDependencies
  )
  const integrationDevDependencies = integrationIds.flatMap(
    (integrationId) => getIntegrationDefinition(integrationId).devDependencies
  )

  return {
    dependencies: unique([...CORE_DEPS, ...presetDependencies, ...integrationDependencies]),
    devDependencies: unique([
      ...DEV_DEPS,
      ...presetDevDependencies,
      ...integrationDevDependencies,
      ...(includeLinter ? LINTER_DEV_DEPS : [])
    ])
  }
}
